import DataPair from "../../common/DataPair";
import {FormGroup} from "@prism/form";
import React, {useEffect, useState} from "react";
import {ELECTRIC_ENGINE_CATEGORIES, PLEASE_SELECT} from "../../../utils/constants";
import Dropdown from "../../common/Dropdown";
import Api from "../../Api";

const BlockType = (props) => {
    const {
        designatedDescription,
        hasDDSResponse,
        onBlockTypeChange
    } = props

    const [options, setOptions] = useState([]);
    const fuelType = designatedDescription?.powertrain?.engine?.fuelCategory;
    const blockType = designatedDescription?.powertrain?.engine?.blockType;
    const isElectric = ELECTRIC_ENGINE_CATEGORIES.includes(fuelType);

    useEffect(() => {
        if (fuelType) {
            async function fetchData() {
                return await Api.getBlockTypes();
            }

            if (!hasDDSResponse) {
                fetchData().then(r => setOptions(r.items?.length ? r.items : []));
            }
        }
    }, [fuelType, hasDDSResponse]);

    if ((!hasDDSResponse && !fuelType) || isElectric) {
        return <></>
    } else {
        return (
            hasDDSResponse ?
                <FormGroup>
                    <DataPair id="configure-block-type" label="Block Type">
                        {blockType}
                    </DataPair>
                </FormGroup> :
                <FormGroup>
                    <DataPair id="configure-block-type" label="Block Type" required={true}>
                        <Dropdown disabled={!fuelType || !options?.length}
                                  onChange={onBlockTypeChange}
                                  value={blockType}
                                  id='block-type-dropdown'>
                            {!blockType && <option value=''>{PLEASE_SELECT}</option>}
                            {options?.map(option => {
                                return (
                                    <option
                                        key={option.name}
                                        value={option.name}>
                                        {option.name}
                                    </option>)
                            })}
                        </Dropdown>
                    </DataPair>
                </FormGroup>
        )
    }
}

export default BlockType;